export const programId = '6042b7f197f2f50065405963';

export const defaultOptions = {
    customCss: ' ',
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
